import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import GenericModal from "./GenericModal";
import ModalUpdateSuccess from "./ModalUpdateSuccess";
import {
  fetchVendorById,
  updateVendorsonhome,
  uploadImage,
} from "./redux/slices/VendorThunks";

export default function Profileeditone({ setActiveItem }) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const vendor = localStorage.getItem("vendor");

  const storedvendor = vendor ? JSON.parse(vendor) : null;

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const [image, setImage] = useState(user?.profile_picture);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setActiveItem("sectors");
  };

  const handleFieldChange = async (key, value) => {
    setUploadError("");
    setIsLoading(true);
    try {
      const res = await dispatch(uploadImage(value));
      setImage(res.payload.fileURL);
    } catch (e) {
      console.log(e, "error");
      setUploadError("Failed to upload image. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!image) {
      setUploadError("Please upload an image first.");
      return;
    }

    setIsLoading(true);
    setUploadError("");

    try {
      const data = { profile_picture: image };

      // Dispatch the update and get the result
      const resultAction = await dispatch(updateVendorsonhome(data));
      console.log("resultAction", resultAction);

      if (updateVendorsonhome.rejected.match(resultAction)) {
        // If the thunk was rejected, show the error from the server
        setUploadError(
          resultAction.payload || "Failed to update profile picture."
        );
        return;
      }

      // Fetch the updated vendor info
      await dispatch(fetchVendorById(user._id));

      // Open modal on success
      openModal();
    } catch (error) {
      console.error("Unexpected error:", error);
      setUploadError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Frame1501_0001>
        <EditProfilePicture>Edit Profile Picture</EditProfilePicture>
        <PRTNR.FileInput
          label="Upload picture"
          helpText="JPG, GIF or PNG. Max file size 800kb"
          accept=".jpg,.jpeg,.gif,.png"
          onChange={(file) => {
            handleFieldChange("", file);
          }}
          name="profile_picture"
          required={true}
          value={image}
          disabled={isLoading}
        />
        {uploadError && <ErrorMessage>{uploadError}</ErrorMessage>}
      </Frame1501_0001>
      <Frame1500>
        <PRTNR.Button
          onClick={() => {
            setImage("");
            setActiveItem("sectors");
          }}
          variant="gray-light"
          disabled={isLoading}
        >
          Cancel
        </PRTNR.Button>

        <Frame1399>
          <PRTNR.Button
            onClick={handleSubmit}
            variant="black"
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </PRTNR.Button>
        </Frame1399>
      </Frame1500>
      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalUpdateSuccess isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
    </>
  );
}

const Frame1501_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const EditProfilePicture = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(18px, 3vw, 24px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const Frame1500 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 17px;
  box-sizing: border-box;

  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
  }
`;

const Frame1399 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
  width: 250px;

  @media (max-width: 640px) {
    width: 100%;
  }
`;

const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  text-align: left;
  display: block;
  margin-top: 4px;
`;
